import Vue from 'vue';
import SearchBar from './vue/components/search/SearchBar';
export default function initSearchBar() {
  const $container = document.querySelector('.cp-search');

  if (!$container) {
    return;
  }

  new Vue({
    el: $container,

    data: {},

    components: {
      SearchBar,
    },
  });
  var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);
}
